import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import LogoPagaliImg from '../../assets/logo-pagali-color@2x.png';

const PendingApproval: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { email, nome, tipoConta } = (location.state as { email?: string; nome?: string; tipoConta?: string }) || {};

  const isDeveloper = tipoConta === 'DEVELOPER';

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-md p-8 text-center">
        <img src={LogoPagaliImg} alt="Pagali" className="h-10 mx-auto mb-8" />

        {/* Checkmark icon */}
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-3">
          Pedido submetido!
        </h1>

        {nome && (
          <p className="text-gray-600 mb-2">
            Olá <span className="font-medium">{nome}</span>,
          </p>
        )}

        <p className="text-gray-600 mb-2">
          O seu pedido de conta foi recebido com sucesso e está em análise pela nossa equipa.
        </p>

        {email && (
          <p className="text-gray-500 text-sm mb-6">
            Irá receber um email em <span className="font-medium text-gray-700">{email}</span> quando a conta for aprovada.
          </p>
        )}

        <div className="bg-pagali-primary/5 border border-pagali-primary/20 rounded-xl p-4 mb-8 text-left">
          <p className="text-sm font-medium text-pagali-primary mb-2">O que acontece a seguir?</p>
          <ul className="space-y-1.5 text-sm text-gray-600">
            <li className="flex items-start gap-2">
              <span className="text-pagali-primary mt-0.5">•</span>
              A equipa Pagali irá analisar o seu pedido em 1–2 dias úteis
            </li>
            <li className="flex items-start gap-2">
              <span className="text-pagali-primary mt-0.5">•</span>
              Receberá um email de confirmação quando a conta for activada
            </li>
            {isDeveloper && (
              <li className="flex items-start gap-2">
                <span className="text-pagali-primary mt-0.5">•</span>
                Após aprovação, terá acesso à sandbox e às chaves de API
              </li>
            )}
          </ul>
        </div>

        <p className="text-xs text-gray-400 mb-6">
          Dúvidas? Contacte-nos em{' '}
          <a
            href={isDeveloper ? 'mailto:developers@pagali.cv' : 'mailto:suporte@pagali.cv'}
            className="text-pagali-primary hover:underline"
          >
            {isDeveloper ? 'developers@pagali.cv' : 'suporte@pagali.cv'}
          </a>
        </p>

        <button
          onClick={() => navigate('/')}
          className="w-full bg-pagali-primary text-white py-3 px-4 rounded-lg font-medium hover:bg-pagali-primary/90 transition-colors"
        >
          Voltar ao início
        </button>
      </div>
    </div>
  );
};

export default PendingApproval;
